import React, { useContext, useState, useEffect } from "react";
import { Container, Spinner } from "react-bootstrap";
import SearchBar from "./components/searchbar/searchbar";
import StatusTabs from "./components/statusTabs/statusTabs";
import ReportTable from "./components/reportTable/reportTable";
// import RejectionHistoryTable from "./components/rejectionHistoryTable/rejectionHistoryTable";
import ReportsService from "../../../../services/reports-service";
import { IdentityContext } from "../../../../context/identity-context";

const AdcuCheckerReportsModule = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [activeTab, setActiveTab] = useState("All");
    const [reports, setReports] = useState([]);
    const [rejectionHistory, setRejectionHistory] = useState([]);
    const [loading, setLoading] = useState(true); // Loading state
    const { user, role } = useContext(IdentityContext);

    const reportsService = new ReportsService();

    useEffect(() => {
        const fetchReports = async () => {
            setLoading(true); // Start loading
            try {
                const response = await reportsService.getReports("adcu_checker");
                setReports(response.reports || []);
                // setRejectionHistory(response.data.rejectionHistory || []);
            } catch (error) {
                console.error("Error fetching reports:", error);
            } finally {
                setLoading(false); // Stop loading
            }
        };
        fetchReports();
    }, [role]);

    const filteredReports = reports.filter((report) => {
        const searchLower = searchTerm.toLowerCase();
        return (
            [report.from, report.institution, report.securityName, report.status, report.dateReceieved]
                .some((attr) => attr?.toString().toLowerCase().includes(searchLower)) ||
            report.clients.some((client) =>
                [client.name, client.bpId, client.isin, client.referenceNo, client.amount.toString()]
                    .some((attr) => attr.toLowerCase().includes(searchLower))
            )
        );
    });

    return (
        <>
            <SearchBar onSearch={setSearchTerm} />
            <Container className="report-container">
                <StatusTabs activeTab={activeTab} setActiveTab={setActiveTab} />
                {loading ? (
                    <div className="text-center my-4">
                        <Spinner animation="border" role="status">
                            <span className="visually-hidden"></span>
                        </Spinner>
                    </div>
                ) : (
                    <ReportTable reports={filteredReports} activeTab={activeTab} />
                )}
            </Container>
        </>
    );
};

export default AdcuCheckerReportsModule;
